import React, { useState, useEffect } from "react";
import FormAccordion from "../../../components/Form/FormAccordion";
import { InputField, SelectField } from "../../../components/Form/FormComponents";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { Button } from "@mui/material";
import ActionSideBar from "./ActionSideBar";
import { DurationOptions } from "../../../Constants";
import { LeaseStructureOptions } from "../data";
import { getFormattedDate } from "../../../utils/DateUtils";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setProductData } from "../LeaseSlice";
import { fetchParameterById } from "../../../utils/commonAPI";
import { toast } from "react-toastify";

const CreateLeaseInfo = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { productData } = useSelector((state) => state.lease);
	const [formData, setFormData] = useState({});

	const getInterestRate = async () => {
		const data = await fetchParameterById("10x1BzFxPU");
		if (data && !data.error) {
			console.log(data);
			setFormData({ interestRate: data?.value });
		} else {
			toast.error("Error fetching interest rate!");
		}
	};

	useEffect(() => {
		getInterestRate();
	}, []);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		// set product data so it can be displayed in the summary page
		dispatch(
			setProductData({
				...productData,
				leaseStructure: formData?.leaseStructure,
				amountToLease: formData?.amountToLease,
				type: "full-investment",
				leaseType: "Quick Lease",
				paidSlots: 4,
				// safetyFunds: formData?.safetyFunds,
				// waitingPeriod: formData?.waitingPeriod,
				leaseDuration: formData?.leaseDuration,
				interestRate: formData?.interestRate,
				paymentType: formData?.paymentType,
			})
		);
		// Navigate to next tab
		navigate("/lease/create_asset/summary");
	};

	return (
		<StyledForm onSubmit={handleSubmit}>
			<ActionSideBar leaseData={productData} />

			<div className='RightSection'>
				<FormAccordion title='Lease Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<label>DATE / TIME</label>
							<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
						</div>

						<div className='form-group'>
							<label>TRN ID</label>
							<InputField name='trnId' value={"---"} />
						</div>

						<div className='form-group'>
							<label>ASSET</label>
							<InputField name='productName' value={productData?.productName} />
						</div>

						<div className='form-group'>
							<label>LEASE TYPE</label>
							<InputField name='leaseType' value='Quick Lease' />
						</div>

						<div className='form-group'>
							<label>INVESTMENT TYPE</label>
							<InputField name='investmentType' value='Full Investment' />
						</div>

						<div className='form-group'>
							<label>LEASE STRUCTURE</label>
							<SelectField
								name='leaseStructure'
								handleChange={handleInputChange}
								isEditable={true}
								value={formData?.leaseStructure}
								options={LeaseStructureOptions}
								required={true}
							/>
						</div>

						{/* <div className='form-group'>
							<label>AMOUNT TO INVEST</label>
							<InputField
								name='amountToLease'
								handleChange={handleInputChange}
								isEditable={true}
								value={formData?.amountToLease}
								type={"tel"}
								required={true}
							/>
						</div> */}

						{/* <div className='form-group'>
							<label>SAFETY FUNDS</label>
							<InputField
								name='safetyFunds'
								handleChange={handleInputChange}
								isEditable={true}
								type={"number"}
								value={formData?.safetyFunds}
								required={true}
							/>
						</div> */}

						{/* <div className='form-group'>
							<label>WAITING PERIOD</label>
							<SelectField
								name='waitingPeriod'
								value={formData?.waitingPeriod}
								handleChange={handleInputChange}
								isEditable={true}
								options={DurationOptions}
								required={true}
							/>
						</div> */}

						<div className='form-group'>
							<label>LEASE DURATION</label>
							<SelectField
								name='leaseDuration'
								value={formData?.leaseDuration}
								handleChange={handleInputChange}
								isEditable={true}
								options={DurationOptions}
								required={true}
							/>
						</div>

						<div className='form-group'>
							<label>INTEREST RATE</label>
							<InputField isEditable={true} value={formData?.interestRate} />
						</div>
					</div>
				</FormAccordion>

				<Button variant='contained' color='primary' type='submit' sx={{ mt: 4, mx: 2, px: 5 }}>
					Proceed
				</Button>
			</div>
		</StyledForm>
	);
};

export default CreateLeaseInfo;
